
import { Link } from 'react-router-dom';
import Container from '@mui/material/Container/Container';
import Box from '@mui/material/Box/Box';
import Typography from '@mui/material/Typography/Typography';
import Stack from '@mui/material/Stack/Stack';
import MuiLink from '@mui/material/Link/Link';

export const AppFooter = () => {
    return (
        <Box component="footer" sx={{ backgroundColor: 'background.default' }}>
            <Container>
                <Box sx={{ py: 3, minHeight: 78 }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap" spacing={2}>
                        <Typography>&copy;2026 Wayfinder</Typography>
                        <Stack direction="row" spacing={3}>
                            <MuiLink component={Link} to="/blog" color="inherit" underline="hover">
                                Blog
                            </MuiLink>
                            <MuiLink component={Link} to="/privacy" color="inherit" underline="hover">
                                Privacy
                            </MuiLink>
                        </Stack>
                    </Stack>
                </Box>
            </Container>
        </Box>
    );
};
